module.exports = __webpack_public_path__ + "img/icon_1.2c39a824.png";